var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoarefCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M4.17 7.34C5.92074 7.34 7.34 5.92074 7.34 4.17C7.34 2.41926 5.92074 1 4.17 1C2.41926 1 1 2.41926 1 4.17C1 5.92074 2.41926 7.34 4.17 7.34Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.9503 19.1193C17.701 19.1193 19.1203 17.7 19.1203 15.9493C19.1203 14.1986 17.701 12.7793 15.9503 12.7793C14.1995 12.7793 12.7803 14.1986 12.7803 15.9493C12.7803 17.7 14.1995 19.1193 15.9503 19.1193Z",
    fill: "#91BC68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2102 1.91016L1.91016 18.2102",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17 7.34C5.92074 7.34 7.34 5.92074 7.34 4.17C7.34 2.41926 5.92074 1 4.17 1C2.41926 1 1 2.41926 1 4.17C1 5.92074 2.41926 7.34 4.17 7.34Z",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9503 19.1193C17.701 19.1193 19.1203 17.7 19.1203 15.9493C19.1203 14.1986 17.701 12.7793 15.9503 12.7793C14.1995 12.7793 12.7803 14.1986 12.7803 15.9493C12.7803 17.7 14.1995 19.1193 15.9503 19.1193Z",
    stroke: "#74B743",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoarefCode);
export default __webpack_public_path__ + "static/media/MoarefCode.792fa6749ad19db642782b9f93f8d8c5.svg";
export { ForwardRef as ReactComponent };